import { SkeletonLine, pxToRem, useStyles } from '@archipro-design/aria';
import * as S from './ArticleTileSkeleton.desktop.style';

export const ArticleTileSkeletonDesktop = () => {
    const { css } = useStyles();

    return (
        <div className={css(S.DesktopContainer)}>
            <SkeletonLine
                width={'100%'}
                height={pxToRem(280)}
                className={css(S.SkeletonImageDesktop)}
            />
            <SkeletonLine
                width={'90%'}
                height={pxToRem(25)}
                className={css(S.SkeletonTitleFirstLineDesktop)}
            />
            <SkeletonLine
                width={'70%'}
                height={pxToRem(25)}
                className={css(S.SkeletonTitleSecondLineDesktop)}
            />
            <SkeletonLine
                width={pxToRem(160)}
                height={pxToRem(15)}
                className={css(S.SkeletonSubheadingFirstLineDesktop)}
            />
            <SkeletonLine width={pxToRem(170)} height={pxToRem(15)} />
        </div>
    );
};
